import { rem } from 'polished';
import styled, { keyframes } from 'styled-components';
import boxBg from '../../assets/images/home/box.png';
import { white } from '../../common/colors';

/*export const StyledHomeTwoMainWrapper = styled.div<{ color?: string }>`
  background-color: ${({ color }) => color || '#05008ca1'};
  width: 100%;
  min-height: 400px;
`;*/

export const StyledHomeTwoMainWrapper = styled.div`
  background-color: transparent;
  width: 100%;
  min-height: 400px;
`;

export const StyledHomeTwoDividerWrapper = styled.div<{ color?: string }>`
  height: 5px;
  width: 100%;
  background: linear-gradient(to right, transparent, ${({ color }) => color || '#005cfd'} 50%, transparent);
  mask-image: linear-gradient(
    to right,
    transparent,
    ${({ color }) => color || '#005cfd'} 0%,
    ${({ color }) => color || '#005cfd'} 100%,
    transparent
  );
  -webkit-mask-image: linear-gradient(
    to right,
    transparent,
    ${({ color }) => color || '#005cfd'} 0%,
    ${({ color }) => color || '#005cfd'} 100%,
    transparent
  );
`;

export const StyledHomeTwoCarouselWrapper = styled.div<{ color?: string }>`
  background-color: ${({ color }) => color || '#05008ca1'};
`;

export const StyledHomeTwoWrapper = styled.div`
  background-color: transparent;
  display: flex;
  justify-content: center;
  gap: 5%;
  width: 80%;
  margin: 0 auto;

  @media (max-width: 1200px) {
    width: 90%;
  }

  @media (max-width: 1268px) {
    flex-direction: column;
  }

  section {
    width: 50%;
    flex: 1;
    padding-bottom: 30px;

    @media (max-width: 1268px) {
      width: 100%;
      flex: 1;
      padding-bottom: 10px;

      :nth-child(2) {
        padding-bottom: 30px;
      }
    }
  }
`;

export const StyledHomeTwoTopWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 2%;
  flex-direction: column;
  width: 80%;
  text-align: center;
  margin: 0 auto;

  @media (max-width: 1200px) {
    width: 90%;
  }
`;

export const StyledHomeTwoTopLogo = styled.section`
  margin-top: 6.5vh;
  margin-bottom: 1.75vh;

  @media (max-width: 768px) {
    margin-top: 2vh;
    margin-bottom: 0.5vh;
  }

  img {
    max-height: 396px;
    max-width: 405px;
    height: auto;
    width: 34%;

    @media (max-width: 768px) {
      height: auto;
      width: 55vw;
      min-width: 192px;
    }

    @media (min-width: 2000px) and (min-height: 1200px) {
      width: 40%;
      max-width: 810px;
      max-height: 792px;
    }
  }
`;

export const StyledHomeTwoTopSocial = styled.section`
  display: block;
  margin: 0 auto;
  margin-bottom: 2vh;

  @media (max-width: 768px) {
    margin-bottom: 0;
  }

  & > div:first-child {
    @media (max-width: 768px) {
      margin-top: 0.5vh;
    }
  }

  & > div:last-child {
    @media (max-width: 768px) {
      margin-bottom: 0;
    }
  }
`;

export const StyledHomeTwoTopSocialSection = styled.div`
  text-align: center;
  transition: transform 0.3s ease;
  opacity: 0.6;
  float: none;
  margin: 4vh auto;

  @media (min-width: 769px) {
    float: left;
    margin: 0 0.7vw;
  }

  @media (min-width: 800px) {
    margin: 0 1.5vw;
  }

  @media (min-width: 1024px) {
    margin: 0 2vw;
  }

  @media (min-width: 1200px) {
    margin: 0 1.6vw;
  }

  @media (min-width: 1300px) {
    margin: 0 2vw;
  }

  @media (min-width: 1600px) {
    margin: 0 2.45vw;
  }

  @media (min-width: 1820px) {
    margin: 0 3.35vw;
  }

  &:hover {
    transform: scale(1.1); /* Zoom effect */
    z-index: 1; /* Bring hovered item above others */
    opacity: 1;
    cursor: pointer;
  }

  &.zoom {
    transform: scale(1.1); /* Zoom effect */
    z-index: 1; /* Bring hovered item above others */
    opacity: 1;
    cursor: pointer;
  }

  p {
    color: #fff;
    font-size: ${rem(24)};
    line-height: 1.1;
    margin: 0;
    padding-bottom: 1vh;

    &:nth-child(2) {
      font-weight: 700;
      padding-bottom: 3.5vh;

      @media (max-width: 1024px) {
        padding-bottom: 2.25vh;
      }

      @media (max-width: 768px) {
        padding-bottom: 1vh;
      }
    }

    @media (max-width: 1600px) {
      font-size: ${rem(22)};
    }

    @media (max-width: 1400px) {
      font-size: ${rem(20)};
    }

    @media (max-width: 1200px) {
      font-size: ${rem(16)};
    }

    @media (max-width: 1024px) {
      font-size: ${rem(14)};
    }

    @media (max-width: 768px) {
      font-size: ${rem(16)};
    }
  }
`;

/*export const StyledHomeTwoTopSocial = styled.section`
  display: flex;
  gap: 1rem;
  margin-bottom: 2vh;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const StyledHomeTwoTopSocialSection = styled.div`
  flex: 1;
  text-align: center;
  transition: transform 0.3s ease;
  opacity: 0.6;

  :hover {
    transform: scale(1.1);
    z-index: 1;
    opacity: 1;
    cursor: pointer;
  }

  p {
    color: #fff;
    font-size: ${rem(24)};
    line-height: 1.1;
    margin: 0;
    padding-bottom: 1vh;

    :nth-child(2) {
      font-weight: 700;
      padding-bottom: 3.5vh;
    }

    @media (max-width: 1600px) {
      font-size: ${rem(22)};
    }

    @media (max-width: 1400px) {
      font-size: ${rem(20)};
    }

    @media (max-width: 1200px) {
      font-size: ${rem(16)};
    }
  }
`;*/

export const StyledHomeTwoTopSocialSectionLinks = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  gap: 1vw;

  img {
    width: 20px;
    height: 20px;
  }
`;

export const StyledHomeTwoOverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  backdrop-filter: blur(6px);
  background-color: rgba(0, 0, 0, 0.6);
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const StyledHomeTwoOverlayClose = styled.img`
  top: 5%;
  right: 2%;
  cursor: pointer;
  position: absolute;

  @media (max-width: 768px) {
    top: 4%;
    right: 4%;
    width: 14px;
    height: auto;
  }
`;

export const StyledHomeTwoOverlayContent = styled.div`
  width: calc(600px - 12rem);
  max-width: calc(80% - 12rem);
  border: 2px solid #1abcfe;
  border-radius: 0.35rem;
  background: url(${boxBg}) no-repeat center center fixed;
  background-size: cover;
  animation: ${fadeIn} 0.3s ease-out;
  color: ${white};
  padding: 0 4rem;
  padding-bottom: 2rem;
  position: absolute;

  @media (max-width: 768px) {
    width: calc(600px - 2rem);
    max-width: calc(80% - 2rem);
    padding: 2rem;
    padding-top: 0;
    padding-bottom: 1.5rem;
  }

  h3 {
    margin: 3rem 0 0 0;
    color: ${white};
    padding-bottom: 1rem;
    font-size: 1.5rem;
    line-height: 1;

    @media (max-width: 768px) {
      margin: 2rem 0 0 0;
      font-size: 1.8rem;
      line-height: 1.2;
    }
  }

  p {
    font-size: 0.75rem;
    line-height: 1.5;
    width: 85%;

    @media (max-width: 768px) {
      margin: 0.2rem 0;
    }
  }
`;

export const StyledHomeTwoOverlayFormContent = styled.div`
  display: flex;
  margin-bottom: 1rem;
`;

export const StyledHomeTwoOverlayFormButton = styled.button`
  padding: 0.5rem 1rem;
  background: #1abcfe;
  color: white;
  border: none;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 1rem;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    padding: 0.5rem;
  }

  img {
    width: 19px;
    height: 16px;
  }
`;

export const StyledHomeTwoOverlayFormInput = styled.input`
  padding: 0.5rem;
  width: 100%;
  font-size: 1rem;
  margin-top: 1rem;
  border: 1px solid #ccc;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;

  @media (max-width: 768px) {
    padding: 0.5rem;
    padding-bottom: 0.4rem;
  }

  &::placeholder {
    opacity: 0.5; /* 50% visibility */
    color: gray; /* optional */
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
  }
`;

export const StyledHomeTwoOverlayFormErrorText = styled.span`
  display: block;
  color: #ff9800;
  font-size: 0.875rem;
  font-weight: bold;
  margin-top: 0.5rem;
  text-shadow: 0.5px 0.5px black;
`;

export const StyledHomeTwoSignUpBtn = styled.div<{ color?: string; gradient1?: string; gradient2?: string }>`
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    display: none;
  }

  p {
    color: #fec200;
    padding: ${rem(4)} ${rem(13)};
    padding-top: ${rem(6)};
    margin: 2vh 0;
    border: 3px solid ${({ color }) => color || '#05008c'};
    border-radius: ${rem(16)};
    background: linear-gradient(
      270deg,
      ${({ gradient1 }) => gradient1 || '#05008c'}90,
      ${({ gradient2 }) => gradient2 || '#05008c'}
    );
    font-size: ${rem(21)};
    line-height: 1;
    cursor: pointer;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
    display: flex;
    gap: ${rem(8)};

    span {
      font-weight: 700;
    }

    svg {
      transform: rotate(90deg);
      transform-origin: center;
      width: ${rem(12)};
      margin: 0 ${rem(4)};
      filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 1));
    }
  }
`;

export const StyledHomeTwoSignUpMobileBtn = styled.div<{ color?: string }>`
  display: none;
  justify-content: center;

  @media (max-width: 768px) {
    display: flex;
  }

  p {
    color: #fec200;
    padding: ${rem(6)} ${rem(13)};
    padding-top: ${rem(8)};
    margin: 2vh 0;
    border: 3px solid ${({ color }) => color || '#05008c'};
    border-radius: ${rem(16)};
    background-color: ${({ color }) => color || '#05008c'}70;
    font-size: ${rem(16)};
    line-height: 1;
    cursor: pointer;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
    display: flex;
    gap: ${rem(8)};

    @media (max-width: 768px) {
      margin: 4vh 0;
    }

    span {
      font-weight: 700;
    }

    svg {
      transform: rotate(90deg);
      transform-origin: center;
      width: ${rem(8)};
      margin: 0 ${rem(8)};
    }
  }
`;

/*export const StyledHomeTwoWrapper = styled.div`
  background-color: ${white};
  display: flex;

  section {
    width: 40%;
    padding 0 5%;
  }
`;*/
